// extracted by mini-css-extract-plugin
export default {"form":"UserInput_form__RO6sH","form-inputs":"UserInput_form-inputs__BBfDU","form-input":"UserInput_form-input__8Emfr","starter":"UserInput_starter__FNuXU"};